import { useRecordContext } from 'react-admin';

export const ScopeField = () => {
  const record = useRecordContext();
  return record.scope.join(', ');
};
